// src/components/layout/Sidebar.tsx
import React from 'react'
import { Users } from 'lucide-react'
import { Button } from '../ui/button'
import { useAuth } from '../../contexts/AuthContext'
import AccountSwitcher from './AccountSwitcher'
import { 
  BarChart3,
  ShoppingBag,
  Wallet,
  User,
  Settings,
  LogOut,
  PlayCircle,
  TrendingUp,
  Handshake
} from 'lucide-react'

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onLogout: () => void;
  stats: {
    bonusLevel: number;
  };
}

export default function Sidebar({ activeTab, onTabChange, onLogout, stats }: SidebarProps) {
  const { user } = useAuth()
  
  const navigationItems = [
    { id: 'dashboard', label: 'Kontrol Paneli', icon: BarChart3 },
    { id: 'orders', label: 'Siparişler', icon: ShoppingBag },
    { id: 'payments', label: 'Ödemeler', icon: Wallet },
    { id: 'earnings', label: 'Kazançlar', icon: TrendingUp },
    { id: 'affiliate', label: 'Satış Ortaklığı', icon: Users },
    { id: 'partners', label: 'Partnerler', icon: Handshake },
    { id: 'profile', label: 'Profil', icon: User },
    { id: 'settings', label: 'Ayarlar', icon: Settings },
    { id: 'how-to-use', label: 'Nasıl Kullanılır?', icon: PlayCircle },
  ]

  return (
    <div className="fixed inset-y-0 left-0 w-64 glass border-r border-orange-200 z-50">
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="p-6 border-b border-orange-200">
          <div className="flex items-center gap-3">
            <img 
              src="/logo512.png" 
              alt="EarnBackHub Logo" 
              className="w-14 h-14 object-contain"
            />
            <div>
          <h1 className="text-2xl font-bold text-orange-600">EarnBackHub</h1>
          <p className="text-sm text-gray-600 mt-1">Kontrol Paneli</p>
        </div>
         </div>
        </div>

{/* Navigation */}
<nav className="flex-1 p-4 space-y-2">
  {navigationItems.map((item) => {
    const Icon = item.icon
    const path = item.id === 'dashboard' ? '/' : `/${item.id}`
    return (
      <a
        key={item.id}
        href={path}
        onClick={(e) => {
          // Ctrl/Cmd/Shift/Alt veya orta tık → tarayıcı yeni sekmede açsın (engelleme)
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return
          e.preventDefault()
          onTabChange(item.id)
        }}
        className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left no-underline transition-all ${
          activeTab === item.id
            ? 'bg-orange-100 text-orange-700 border-r-2 border-orange-500'
            : 'text-gray-600 hover:bg-orange-50 hover:text-orange-600'
        }`}
      >
        <Icon className="w-5 h-5" />
        <span className="flex-1">{item.label}</span>
      </a>
    )
  })}
</nav>

        {/* User Profile */}
        <div className="p-4 border-t border-orange-200">
          <div className="mb-3">
            <AccountSwitcher />
          </div>
          <Button 
            variant="ghost" 
            className="w-full justify-start text-muted-foreground hover:text-red-400 hover:bg-red-500/10"
            onClick={onLogout}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Çıkış Yap
          </Button>
        </div>
      </div>
    </div>
  )
}